<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; dislay: flex; margin-top: 100px"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div class="QZ07">
        <div class="position">
          <div style="display: flex; flex-direction: column">
            <div class="display_quiz">
              <div
                v-if="getWidth >= 1025 && disablePrevbtn == false"
                class="icon_arrow"
              >
                <div class="arrow_left" @click="onPrev">
                  <img
                    style="width: 40%; height: 40%"
                    src="@/assets/images/CH2/left-arrow.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="card">
                <div class="block">
                  <CRow style="margin-bottom: 1%">
                    <CCol col="12" style="display: flex">
                      <div :class="checkLangClass()">
                        <p>
                          {{ checkLanguage(title) }}
                        </p>
                      </div>
                    </CCol>
                  </CRow>
                </div>
                <div class="container_body">
                  <div class="choise_container">
                    <div
                      class="choise_body card_choise_1"
                      v-for="(item, index) in question"
                      :key="index"
                    >
                      <div
                        v-bind:class="
                          choise_ans.includes(index)
                            ? 'select_active'
                            : 'choise_left'
                        "
                        v-bind:style="
                          choiseSelect == index ? style_selectChoise : ''
                        "
                        @click="selectquestion(index)"
                      >
                        <div class="border_left">
                          {{ choiseTitle[index] }}
                        </div>
                      </div>
                      <div class="fontChinese font_left">{{ item }}</div>
                    </div>
                  </div>
                  <div class="ans_container">
                    <div class="ans_body card_ans_1">
                      <div
                        class="choise_left"
                        @click="selectAns(choiseSelect, 0)"
                      >
                        <div
                          class="border_left"
                          v-bind:class="
                            choise_ans[0] != null ? 'text_active' : ''
                          "
                        >
                          {{ getChoise(0) }}
                        </div>
                      </div>
                      <div class="choise_right">{{ choise[0] }}</div>
                    </div>
                    <div class="ans_body card_ans_2">
                      <div
                        class="choise_left"
                        @click="selectAns(choiseSelect, 1)"
                      >
                        <div
                          class="border_left"
                          v-bind:class="
                            choise_ans[1] != null ? 'text_active' : ''
                          "
                        >
                          {{ getChoise(1) }}
                        </div>
                      </div>
                      <div class="choise_right">{{ choise[1] }}</div>
                    </div>
                    <div class="ans_body card_ans_3">
                      <div
                        class="choise_left"
                        @click="selectAns(choiseSelect, 2)"
                      >
                        <div
                          class="border_left"
                          v-bind:class="
                            choise_ans[2] != null ? 'text_active' : ''
                          "
                        >
                          {{ getChoise(2) }}
                        </div>
                      </div>
                      <div class="choise_right">{{ choise[2] }}</div>
                    </div>
                    <div class="ans_body card_ans_4">
                      <div
                        class="choise_left"
                        @click="selectAns(choiseSelect, 3)"
                      >
                        <div
                          class="border_left"
                          v-bind:class="
                            choise_ans[3] != null ? 'text_active' : ''
                          "
                        >
                          {{ getChoise(3) }}
                        </div>
                      </div>
                      <div class="choise_right">{{ choise[3] }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="icon_arrow" v-if="getWidth >= 1025">
                <div class="arrow_right" @click="submit_ans">
                  <img
                    style="width: 40%; height: 40%"
                    src="@/assets/images/CH2/right-arrow.png"
                    alt=""
                  />
                </div>
              </div>
              <div v-else class="menu_btn">
                <div class="btn_prev" v-if="disablePrevbtn == false">
                  <div class="btn_left" @click="onPrev">
                    <div class="font_prev">
                      <b>PREVIOUS</b>
                    </div>
                  </div>
                </div>
                <div class="btn_next">
                  <div class="btn_right" @click="submit_ans">
                    <div class="font_next">
                      <b>NEXT</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import AudioList from '@/components/elements/audio/AudioList';
import CheckBox from '@/components/elements/Checkbox/Checkbox';
import LoadingMDL from '@/components/loading/LoadingMDL';
import '../../../assets/scss/chinessStyle2.scss';

export default {
  components: {AudioList, CheckBox, LoadingMDL},
  name: 'QZ07',
  props: {},
  data() {
    return {
      loading: false,
      language: '',
      currentRoute: '',
      choiseSelect: null,
      choiseTitle: ['a', 'b', 'c', 'd'],
      question: [],
      title: [
        {
          key: 'th',
          value: 'กรุณาจับคู่คำศัพท์ด้านล่างนี้',
        },
        {
          key: 'cn',
          value: '请选择对应的答案。',
        },
        {
          key: 'en',
          value: 'Please matching this vocabulary below',
        },
      ],
      navigation: [],
      choise: [],
      score: 0,
      answer: [],
      content: [],
      choise_ans: [null, null, null, null],
      style_selectChoise: {},
      getWidth: window.innerWidth,
      startTime: '',
      condition: [],
      criteria_id: '',
      disablePrevbtn: false,
      topic: {},
      chapter: null,
      // code: "605418cb883ae722ba1b0c5f",
      code: '',
      v3Score: 0,
      trueAns: [],
    };
  },
  methods: {
    onLoadData() {
      //clear local state before dispatch
      this.resetLocalState();

      this.currentRoute = this.$route.name + '-' + this.$route.params.id;

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },
    checkLangClass() {
      if (this.language == 'CN') {
        return 'fontChinese font_setting';
      } else {
        return 'font_setting';
      }
    },
    selectquestion: function (val) {
      this.choiseSelect = val;
      this.style_selectChoise = {
        backgroundColor: '#1e5bd7',
      };
    },
    getChoise: function (index) {
      if (this.choise_ans.length > 0) {
        return this.choiseTitle[this.choise_ans[index]];
      } else {
        return '';
      }
    },
    selectAns: function (questionSelect, indexAns) {
      for (let i = 0; i < this.choise_ans.length; i++) {
        if (questionSelect == this.choise_ans[i]) {
          this.choise_ans[i] = null;
        }
      }
      this.choise_ans.splice(indexAns, 1, questionSelect);
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.language) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error 1!!');
        }
      } else {
        console.log('change language is error 2!!');
      }
    },
    submit_ans: function () {
      if (this.choise_ans.includes(null)) {
        return alert('please select all answer');
      }

      this.choise_ans.map((item, index) => {
        this.answer.push({
          match: this.question[item],
          answer: this.choise[index],
          index: this.content[item].order,
        });
      });
      this.commitUserProgress();
    },
    commitUserProgress: function () {
      this.loading = true;

      //check answer is correct
      const checkResult = this.checkAnswer(this.content, this.answer);

      // if check Result is true return score  if not return nothing
      if (checkResult) {
        this.v3Score = checkResult;
        console.log('This is correct answer');
      }

      // //stamp progress
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: this.answer, // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: this.v3Score,
          maxScore: 4,
        },
      ];

      this.$store.dispatch('v3/saveContent', data);

      //redirect
      const str = this.navigation.next.action.split('-');
      const path = `/v3/${str[0]}/${str[1]}`;
      this.$router.push(path);
    },
    onPrev: function () {
      this.resetLocalState();

      if (this.navigation.previous.action != '') {
        let str = this.navigation.previous.action.split('-');
        let path = `/v3/${str[0]}/${str[1]}`;
        this.$router.push(path);
      }
    },
    resetLocalState() {
      this.choiseSelect = null;
      this.question = [];
      this.choise = [];
      this.score = 0;
      this.answer = [];
      this.content = [];
      this.choise_ans = [null, null, null, null];
      this.style_selectChoise = {};
      this.v3Score = 0;
    },
    checkAnswer(correct, selected) {
      let trueAnswer = [];

      // //format data into true answer
      correct.map((item) => {
        trueAnswer.push({
          answer: item.choices[0].question,
          order: item.order,
          ch: item.item.data,
        });
      });

      //map check two data
      const result = selected.map((sel) =>
        trueAnswer.some((ans) => this.isCorrectAnswer(ans, sel))
      );
      //return array check
      //return score like this if true false true score = 4
      const score = result.filter(Boolean).length;

      return score;

      //check is every result is true
      // return result.every((status) => status === true);
    },
    isCorrectAnswer(trueAns, selectedAns) {
      return (
        trueAns.answer === selectedAns.answer &&
        trueAns.order === selectedAns.index &&
        trueAns.ch === selectedAns.match
      );
    },
  },
  computed: {
    ...mapGetters({
      // getTemplateAndProgress: 'template/getTemplateAndProgress',
      // getResponseStatus: 'template/getResponseStatus',
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;
      console.log(val);

      this.v3Data = val;
      const template = val.templates[0];
      // let templateType = ['pretest', 'posttest'];
      // this.disablePrevbtn = templateType.includes(val.topicPosition.type);

      //content
      this.navigation = template.navigate;
      this.question = template.content.item.map((i) => {
        return i.item.data;
      });

      this.content = template.content.item;
      template.content.item.map((i) => {
        this.choise.push(i.choices[0].question);
      });

      if (this.choise.length == 4) {
        this.choise = this.choise.sort(() => Math.random() - 0.5);
      }

      this.loading = false;
    },
    // getTemplateAndProgress: function (value) {
    //   let templateType = ['pretest', 'posttest'];
    //   this.disablePrevbtn = templateType.includes(value.topicPosition.type);

    //   this.startTime = this.$helpers.getDateFormat();
    //   if (value.criteria.condition.criteriaType.length != 0) {
    //     this.condition.push({
    //       criteria: value.criteria.condition.criteriaType[0]._id,
    //       val: value.criteria.condition.criteriaType[0].val,
    //     });
    //   }
    //   this.criteria_id = value.criteria._id;
    //   this.chapter = value.chapter;
    //   this.topic = value.topicPosition;

    //   this.navigation = value.templateData.navigate;
    //   this.question = value.templateData.content.item.map((i) => {
    //     return i.item.data;
    //   });
    //   this.content = value.templateData.content.item;
    //   value.templateData.content.item.map((i) => {
    //     this.choise.push(i.choices[0].question);
    //   });
    //   if (this.choise.length == 4) {
    //     this.choise = this.choise.sort(() => Math.random() - 0.5);
    //   }
    //   this.loading = false;
    // },
    // getResponseStatus: function (val) {
    //   if (val.status == 200) {
    //     this.choiseSelect = null;
    //     this.question = [];
    //     this.choise = [];
    //     this.score = 0;
    //     this.answer = [];
    //     this.content = [];
    //     this.choise_ans = [null, null, null, null];
    //     this.style_selectChoise = {};
    //     let str = this.navigation.next.action.split('-');
    //     let body = '/' + str[0] + '/' + str[1];
    //     if (str[0] == this.$route.name) {
    //       let payload = {
    //         templateCode: this.navigation.next.action,
    //         code: this.code,
    //         // section: "testing",
    //         section: this.section,
    //       };
    //       this.$store.dispatch('template/fetchTemplateAndProgress', payload);
    //       if (this.disablePrevbtn) {
    //         this.$router.replace(body);
    //       }
    //       this.$router.push(body);
    //       this.loading = true;
    //     } else {
    //       this.$router.push(body);
    //     }
    //   }
    // },
    storeLanguage: function (val) {
      this.language = val;
    },
    '$route.params.id'() {
      //use to watch param id if changes
      // this.loading = true;

      this.onLoadData();
    },
  },
  created() {
    this.courseData = this.$store.getters['necessary/getLerningCourse'];
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection'];
  },
  mounted() {
    this.language = this.$store.getters['language/getLanguage'];
    // let payload = {
    //   templateCode: this.currentRoute,
    //   code: this.code,
    //   // section: "testing",
    //   section: this.section,
    // };
    // this.$store.dispatch('template/fetchTemplateAndProgress', payload);
    this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
* {
  user-select: none;
}
::v-deep .step-progress__wrapper {
  width: 70%;
  margin-right: 20%;
}
::v-deep .step-progress__wrapper-before {
  top: 45%;
  height: 10px;
  opacity: 0.5;
  background-color: #3b3b38 !important;
}

::v-deep .step-progress__step--valid:after {
  background-color: #1d5bd7;
}
::v-deep .step-progress__step--valid:after {
  border: #1d5bd7 solid !important;
}
::v-deep .step-progress__step--active:after {
  border: #1d5bd7 solid !important;
}
::v-deep .step-progress__step--active .step-progress__step-label,
.step-progress__step--active span {
  color: #1d5bd7;
}
::v-deep .step-progress__wrapper-after {
  top: 45%;
  height: 10px;
  background-color: #1d5bd7 !important;
  opacity: 0.5;
}
::v-deep .step-progress__step span {
  font-size: 0px;
}
::v-deep svg:not(:root).svg-inline--fa {
  width: 20px;
  height: 20px;
}
::v-deep .step-progress__step-label {
  top: -50px;
}
::v-deep .step-progress__step--valid .step-progress__step-label {
  color: #1d5bd7;
}
::v-deep .step-progress__step:after {
  width: 40px;
  height: 40px;
  border: #808080 solid;
}
::v-deep .step-progress__bar {
  margin-bottom: 10px;
  height: 6s0px;
}
.font_prev {
  color: #1d5bd7;
  font-size: 16px;
}
.font_next {
  color: white;
  font-size: 16px;
}
.btn_prev {
  margin-right: 5%;
  margin-left: 5%;
  margin-top: 5%;
}
.btn_next {
  margin-right: 5%;
  margin-left: 5%;
  margin-top: 5%;
}
.display_quiz {
  display: flex;
  flex-direction: row;
}
.btn_left {
  width: 100px;
  height: 50px;
  border-radius: 10px;
  background-color: #e6efff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn_right {
  width: 100px;
  height: 50px;
  border-radius: 10px;
  background-color: #1d5bd7;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.QZ07 {
  background-color: #ffccd5;
  padding-bottom: 5%;
  padding-top: 5%;
}
.position {
  display: flex;
  align-content: center;
  justify-content: center;
  padding-top: 8%;
  padding-bottom: 8%;
}

.icon_arrow {
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 2%;
  margin-right: 2%;
}
.arrow_left,
.arrow_right {
  width: 60px;
  height: 60px;
  background-color: #e6efff;
  cursor: pointer;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.block {
  background-color: #e6efff;
  width: 100%;
  height: auto;
  border-radius: 7px;
  margin-bottom: 1%;
}

.font_setting {
  padding: 20px 20px 0px 20px;
  color: black;
  font-size: 22px;
}

.font_left {
  font-size: 25px;
  font-weight: bold;
}
.choise_right {
  font-size: 20px;
  font-weight: bold;
}
.border_left {
  font-size: 25px;
  color: #b3cfff;
}
.text_active {
  color: #1e5bd7;
  border: 3px solid #1e5bd7 !important;
}

.select_active {
  background-color: #1e5bd7;
  width: 25%;
  height: 100%;
  border-radius: 5px;
  display: flex;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.choise_left {
  width: 25%;
  height: 100%;
  border-radius: 5px;
  display: flex;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.border_left {
  border-radius: 5px;
  height: 75%;
  width: 80%;
  border: 3px solid #b3cfff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.choise_right {
  width: 75%;
  padding-left: 10px;
}

.choise_container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 50%;
}
.ans_container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 50%;
  margin-left: 20px;
}

.choise_body,
.ans_body {
  display: flex;
  border-radius: 10px;
  background-color: #e6efff;
  height: 60px;
  align-items: center;
  margin-top: 25px;
}
.container_body {
  display: flex;
}
.card {
  background-color: white;
  width: 700px;
  height: 100%;
  padding: 20px 20px 30px 20px;
  margin: auto 0;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px; /* 5px rounded corners */
}

.ContentProgressBar {
  display: flex;
  justify-content: center;

  .ProgressBar {
    background-color: #e6efff !important;
    margin-top: 3%;
    margin-bottom: 3%;
    width: 100%;
    height: 10px;
    border-radius: 10px !important;
  }
}

.progress-bar-striped {
  background-image: none !important;
}

@media only screen and (min-width: 300px) and (max-width: 415px) {
  .display_quiz {
    flex-direction: column;
  }
  .font_setting {
    font-size: 16px;
  }
  .QZ07 {
    background-color: #ffccd5;
    padding-top: 20%;
    padding-bottom: 10%;
    display: flex;
    align-content: center;
    justify-content: center;
  }
  .position {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
  }
  .card {
    width: 350px;
    height: auto;
  }
  .arrow_left {
    width: 100px;
    height: 50px;
    border-radius: 10px;
  }
  .arrow_right {
    width: 100px;
    height: 50px;
    border-radius: 10px;
  }
  .container_body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      'choise_container ans_container'
      'choise_container ans_container';
    gap: 5px;
  }

  .choise_container {
    width: 100%;
    grid-area: choise_container;
  }

  .ans_container {
    width: 100%;
    grid-area: ans_container;

    margin-left: 0;
  }

  .card_ans_1 {
    grid-area: card_ans_1;
  }

  .border_left {
    font-size: 15px;
    height: 50%;
    width: 80%;
  }
  .choise_right {
    padding-left: 5px;
  }
  .choise_right {
    font-size: 15px;
  }
  .font_left {
    font-size: 16px;
  }
  ::v-deep .step-progress__wrapper {
    width: 70%;
    margin: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .QZ07 {
    background-color: #ffccd5;
    padding-bottom: 10%;
    display: flex;
    align-content: center;
    justify-content: center;
  }
  .display_quiz {
    flex-direction: column;
  }
  .position {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
  }
  ::v-deep .step-progress__wrapper {
    width: 90%;
    margin: auto;
  }
}
</style>
